import React, { useCallback, useEffect, useState } from "react";
import { Swiper, SwiperClass, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/swiper-bundle.css";

const mentorServices = [
  {
    id: 1,
    title: "Academic Counseling",
    height: "h-[190px]",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="76"
        height="76"
        viewBox="0 0 76 76"
        fill="none"
      >
        <path
          d="M59.238 36.6411C59.8584 34.5167 61.6632 33.4263 63.9568 33.6143C65.6676 33.7647 67.4348 35.5883 67.5664 37.4119C67.9048 42.6947 67.98 48.1467 67.5664 53.4107C67.3784 55.9299 65.8368 57.6971 63.2424 57.7911C59.4448 57.9227 55.6472 57.5279 51.8684 57.5655C51.4548 57.5655 51.0224 57.7159 50.8532 58.1295C50.7592 58.3739 50.7592 58.6559 50.7592 58.9379C50.8156 61.2691 50.8532 63.6003 50.8344 65.9127C50.8344 66.9091 50.9848 67.9431 50.5712 68.8831C49.932 70.3307 48.0896 71.5339 46.6044 70.4435C46.0028 69.9923 45.6644 69.2591 45.5516 68.5071C45.3636 67.3415 45.5516 66.0819 45.5516 64.9163C45.5516 63.6379 45.5328 62.3783 45.5516 61.0999C45.5516 59.5583 45.5704 58.0167 45.6456 56.4751C45.702 55.1215 45.6456 53.6739 46.7172 52.6775C47.4128 52.0383 48.2588 51.9067 49.18 51.8315C51.9624 51.6435 54.82 51.8315 57.6024 51.8503C58.1476 51.8503 58.9184 51.8315 59.1816 51.2487C59.5388 50.4779 58.7868 49.2747 58.7116 48.4851C58.58 47.1879 58.7304 45.7027 59.5388 44.6311C60.0652 43.9355 60.7796 43.4279 61.4376 42.8639C62.716 41.7359 65.1976 40.3071 64.972 38.3143C64.8216 37.0359 63.8252 35.6635 62.4716 35.4567C61.3248 35.2875 60.178 36.0959 59.2192 36.6035L59.238 36.6411Z"
          fill="#00CC99"
        />
        <path
          d="M49.4996 41.6607C49.8756 41.6607 50.2516 41.7171 50.6276 41.7547C51.7932 41.9239 53.0152 42.2059 54.1808 41.8863C55.2336 41.6043 55.8164 40.9087 56.5308 40.1755C57.2828 39.4047 58.1664 38.7467 58.9748 38.0511C59.4824 37.5999 60.0276 37.1863 60.6104 36.8291C61.3436 36.3779 62.2836 36.0959 63.0732 36.6223C63.8064 37.1299 64.4832 38.4271 63.938 39.2355C63.3928 40.0439 62.4528 40.7019 61.7384 41.3787C60.8548 42.2059 59.9524 43.0331 59.0688 43.8603C57.7152 45.1011 56.3052 46.6051 54.3312 46.4923C52 46.3607 49.65 46.2291 47.3188 46.0787C46.7172 46.0411 46.0968 46.0035 45.5328 45.7779C44.5176 45.3455 43.8596 43.9543 44.48 42.9579C45.0064 42.0931 46.2284 41.8299 47.1684 41.7359C47.958 41.6607 48.7476 41.6231 49.5372 41.6607H49.4996Z"
          fill="#00CC99"
        />
        <path
          d="M53.9739 72.9816C55.9103 71.1768 58.4295 69.9736 61.2119 69.6916V61.476L55.0831 61.5888C54.3875 61.5888 53.8047 61.0436 53.7859 60.3292C53.7859 59.6336 54.3311 59.0508 55.0455 59.032L68.9011 58.7688L72.7175 42.6948C72.8867 42.018 73.5635 41.5856 74.2591 41.7548C74.9359 41.924 75.3683 42.6008 75.1991 43.2964L70.9315 61.288L63.7687 61.4196V69.6728C66.5511 69.9548 69.0703 71.158 71.0067 72.9628C71.8527 73.7524 71.2887 75.1812 70.1419 75.1812C69.8223 75.1812 69.5215 75.0684 69.2771 74.8428C67.4911 73.1884 65.1035 72.1732 62.4903 72.1732C59.8771 72.1732 57.4895 73.1884 55.7035 74.8428C55.4779 75.0684 55.1583 75.1812 54.8387 75.1812C53.6731 75.1812 53.1279 73.7524 53.9739 72.9628V72.9816Z"
          fill="#00CC99"
        />
        <path
          d="M66.7532 27.4331C67.3176 24.3276 65.2575 21.3525 62.152 20.7881C59.0464 20.2238 56.0714 22.2838 55.507 25.3894C54.9426 28.4949 57.0027 31.47 60.1082 32.0343C63.2138 32.5987 66.1888 30.5387 66.7532 27.4331Z"
          fill="#00CC99"
        />
        <path
          d="M29.6655 45.9471C27.6727 46.1727 25.6423 46.1915 23.6495 46.4171C22.2207 46.5675 20.5099 46.8683 19.3255 45.8155C17.2011 43.9355 14.9827 42.1495 12.8959 40.2319C12.1627 39.5739 10.9971 38.9159 11.7867 37.5435C12.4259 36.4343 13.4035 36.1711 14.7947 36.7539C16.1483 37.3179 17.3139 38.2391 18.4231 39.1979C19.5135 40.1379 20.5851 41.2095 21.9763 41.6795C23.4051 42.1495 25.0031 41.8675 26.4695 41.7359C27.9359 41.6043 29.4211 41.5855 30.8687 41.8487C31.5267 41.9615 32.2411 42.2623 32.6171 42.8263C33.2563 43.7851 32.5983 45.0447 31.6583 45.5147C31.2071 45.7403 30.6995 45.8155 30.2107 45.8907C30.0227 45.9095 29.8347 45.9471 29.6467 45.9659L29.6655 45.9471Z"
          fill="#00CC99"
        />
        <path
          d="M7.18075 23.1428C7.55675 23.1616 8.00795 23.218 8.23355 23.5564C8.49675 23.9512 8.06435 24.2144 7.87635 24.4776C7.04915 25.6244 6.89875 26.9028 7.10555 28.2564C7.46275 30.5124 4.81195 32.9376 2.55595 32.3924C2.21755 32.3172 1.99195 32.1104 1.91675 31.7532C1.82275 31.302 2.14235 31.208 2.44315 31.0952C3.75915 30.6252 4.15395 29.6852 4.00355 28.3504C3.83435 26.884 3.92835 25.474 4.98115 24.2896C5.56395 23.6504 6.25955 23.218 7.18075 23.1428Z"
          fill="#00CC99"
        />
        <path
          d="M21.262 72.9816C19.3256 71.1768 16.8064 69.9736 14.024 69.6916V61.476L20.1528 61.5888C20.8484 61.5888 21.4312 61.0436 21.45 60.3292C21.45 59.6336 20.9048 59.0508 20.1904 59.032L6.33475 58.7688L2.51835 42.6948C2.34915 42.018 1.67235 41.5856 0.976752 41.7548C0.299952 41.924 -0.132448 42.6008 0.0367519 43.2964L4.30435 61.288L11.4672 61.4196V69.6728C8.68475 69.9548 6.16555 71.158 4.22915 72.9628C3.38315 73.7524 3.94715 75.1812 5.09395 75.1812C5.41355 75.1812 5.71435 75.0684 5.95875 74.8428C7.74475 73.1884 10.1324 72.1732 12.7456 72.1732C15.3588 72.1732 17.7464 73.1884 19.5324 74.8428C19.758 75.0684 20.0776 75.1812 20.3972 75.1812C21.5628 75.1812 22.108 73.7524 21.262 72.9628V72.9816Z"
          fill="#00CC99"
        />
        <path
          d="M20.191 27.7095C20.9118 24.6365 19.0049 21.561 15.9319 20.8402C12.8589 20.1195 9.78341 22.0264 9.06264 25.0994C8.34187 28.1724 10.2487 31.2479 13.3218 31.9686C16.3948 32.6894 19.4703 30.7825 20.191 27.7095Z"
          fill="#00CC99"
        />
        <path
          d="M29.6468 55.0651C29.628 53.8995 29.5528 52.5272 28.688 51.8316C27.9924 51.2676 27.0524 51.3239 26.2064 51.3803C25.1724 51.4555 24.1572 51.512 23.1232 51.5308C22.5592 51.5308 16.3928 51.6247 16.3928 51.5871C16.3928 49.9139 16.3364 48.222 16.3552 46.5488C16.3552 45.59 16.3176 44.6311 15.622 43.8979C14.6632 42.8827 13.4788 42.0932 12.4824 41.1156C11.7492 40.4012 10.8468 39.6491 10.6776 38.5775C10.5272 37.5624 10.9784 36.4908 11.862 35.9456C13.1216 35.156 14.7948 35.7952 16.092 36.1524C15.7912 35.062 15.2836 34.4791 14.306 34.0091C11.2228 32.5239 7.51917 34.7235 7.48157 38.1451C7.42517 42.9015 7.48158 47.6767 7.50038 52.4331C7.50038 56.0615 9.54958 57.9228 13.178 57.7348C16.6748 57.5467 20.2468 57.2459 23.7436 57.2459C23.9692 57.2459 24.2136 57.3024 24.3452 57.4716C24.4768 57.6408 24.4768 57.8663 24.4768 58.0731C24.4768 61.3255 24.552 64.5779 24.552 67.8303C24.5708 69.7855 25.6236 70.9323 27.3156 70.9323C28.8384 70.9323 29.8348 69.6539 29.816 67.7551C29.7972 65.2923 29.7408 62.8107 29.722 60.3479C29.722 58.8439 29.722 57.3587 29.6656 55.8547C29.6656 55.6103 29.6656 55.3284 29.6468 55.0276V55.0651Z"
          fill="#00CC99"
        />
        <path
          d="M51.8308 47.6204H23.4052C22.672 47.6204 22.0892 48.2032 22.0892 48.9364C22.0892 49.6696 22.672 50.2524 23.4052 50.2524H36.302V70.2932H32.5044C32.0908 70.2932 31.7712 70.6128 31.7712 71.0264C31.7712 71.44 32.0908 71.7596 32.5044 71.7596H42.7316C43.1452 71.7596 43.4648 71.44 43.4648 71.0264C43.4648 70.6128 43.1452 70.2932 42.7316 70.2932H38.934V50.2524H51.8308C52.564 50.2524 53.1468 49.6696 53.1468 48.9364C53.1468 48.2032 52.564 47.6204 51.8308 47.6204Z"
          fill="#00CC99"
        />
        <path
          d="M40.9078 25.0228C39.7986 25.0228 38.7082 25.0228 37.599 25.0228C36.4522 25.0228 35.3242 25.0228 34.1774 25.0228C33.7074 25.0228 33.4442 25.3988 33.5946 25.85C33.6886 26.1508 33.9142 26.3012 34.2714 26.3012C36.4898 26.3012 38.6894 26.3012 40.9078 26.3012C41.3402 26.3012 41.6222 26.0192 41.6222 25.6244C41.6222 25.2484 41.3402 25.0228 40.9078 25.0228Z"
          fill="#173CBA"
        />
        <path
          d="M40.9078 27.0908C40.7762 27.0156 40.6258 27.0156 40.4754 27.0156C38.8962 27.0156 37.3358 27.0156 35.7566 27.0156C35.343 27.0156 34.9482 27.0156 34.5346 27.0344C34.3842 27.0344 34.2526 27.072 34.1398 27.1848C33.933 27.3728 33.8766 27.6548 33.9706 27.9368C34.0834 28.2 34.2902 28.3316 34.6474 28.3316C35.625 28.3316 36.5838 28.3316 37.5614 28.3316C37.8998 28.3316 38.2382 28.3316 38.5766 28.3316C39.2722 28.3316 39.949 28.3316 40.6446 28.3316C40.9454 28.3316 41.171 28.106 41.2274 27.8052C41.2838 27.5232 41.1522 27.26 40.889 27.1096L40.9078 27.0908Z"
          fill="#173CBA"
        />
        <path
          d="M39.6483 29.0272C38.9715 29.0272 38.2947 29.0272 37.6179 29.0272C36.9599 29.0272 36.3019 29.0272 35.6439 29.0272C35.3055 29.0272 35.3055 29.0272 35.3995 29.3656C35.7191 30.3244 36.6403 31.0012 37.6555 30.9824C38.6519 30.9636 39.5543 30.2304 39.8363 29.2716C39.8927 29.0836 39.8363 29.0272 39.6483 29.0272Z"
          fill="#173CBA"
        />
        <path
          d="M32.4478 7.65159C29.8158 9.86999 28.8382 13.2916 29.9662 16.4124C30.3986 17.6344 31.1506 18.6496 32.0154 19.5896C32.7486 20.398 33.369 21.2816 33.5382 22.3908C33.6134 22.8984 33.6134 23.406 33.5946 23.9136C33.5946 24.1956 33.7074 24.2896 33.9706 24.2708C34.4218 24.2708 34.873 24.2708 35.3242 24.2708C35.5122 24.2708 35.5498 24.2144 35.5498 24.0264C35.5498 22.0336 35.5498 20.0408 35.5498 18.048C35.5498 17.5968 35.3994 17.202 35.0986 16.8636C34.873 16.6004 34.6474 16.356 34.4594 16.074C33.9894 15.4348 33.6886 14.7204 33.7826 13.8932C33.8766 13.1224 34.403 12.5396 35.0422 12.5208C35.2302 12.5208 35.343 12.4456 35.4558 12.2952C36.001 11.5432 36.847 11.4492 37.5238 12.0508C37.5802 12.0884 37.599 12.1448 37.6742 12.0696C38.5578 11.4304 39.1407 11.5056 39.8175 12.3892C39.8739 12.4644 39.9302 12.5208 40.043 12.5208C40.5318 12.5208 40.8891 12.7464 41.1335 13.1412C41.5095 13.7428 41.4906 14.382 41.2838 15.04C41.0582 15.7732 40.5506 16.3184 40.0806 16.9012C39.7422 17.296 39.573 17.7472 39.573 18.2736C39.573 19.2136 39.573 20.1348 39.573 21.0748C39.573 22.0712 39.573 23.0488 39.573 24.0452C39.573 24.2332 39.6295 24.2896 39.8175 24.2896C40.2875 24.2896 40.7575 24.2896 41.2275 24.2896C41.4907 24.2896 41.5846 24.1768 41.5658 23.9324C41.5658 23.7632 41.5658 23.5752 41.5658 23.3872C41.5282 22.3344 41.8102 21.3944 42.4118 20.5484C42.8066 19.9844 43.2578 19.4956 43.6902 18.9692C44.7806 17.672 45.5138 16.2244 45.6642 14.5324C45.871 12.0508 45.0627 9.90759 43.2955 8.14039C40.3251 5.16999 35.6438 4.96319 32.4102 7.65159H32.4478Z"
          fill="#173CBA"
        />
        <path
          d="M35.625 14.7768C35.3054 14.4196 35.1926 13.9684 35.1926 13.4984C35.1926 13.254 35.0798 13.2916 34.9482 13.3668C34.7414 13.4796 34.6474 13.6676 34.6098 13.8932C34.5346 14.288 34.6286 14.664 34.7978 15.0212C35.0046 15.4724 35.3242 15.8108 35.6438 16.168C36.1702 16.7508 36.4334 17.4088 36.4146 18.1984C36.4146 20.0408 36.4146 21.8644 36.4146 23.7068C36.4146 24.2708 36.4146 24.2708 36.9786 24.2708C37.1854 24.2708 37.2418 24.2144 37.2418 24.0076C37.2418 22.5976 37.2418 21.1876 37.2418 19.7776C37.2418 18.3488 37.2418 16.92 37.2418 15.4912C37.2418 15.3784 37.2606 15.2656 37.0726 15.3032C36.4898 15.4348 36.0198 15.2092 35.6438 14.7768H35.625Z"
          fill="#173CBA"
        />
        <path
          d="M40.0618 13.8556C39.9302 14.9272 38.9902 15.5476 38.2006 15.3032C37.9938 15.228 38.0314 15.3784 38.0314 15.4912C38.0314 16.9012 38.0314 18.3112 38.0314 19.7212C38.0314 21.0936 38.0314 22.4472 38.0314 23.8196C38.0314 24.2708 38.0314 24.252 38.5014 24.2896C38.7646 24.2896 38.821 24.2144 38.821 23.9512C38.821 22.1088 38.821 20.2664 38.821 18.424C38.821 17.5216 39.103 16.7884 39.7046 16.1492C40.1558 15.6792 40.5506 15.1528 40.6634 14.4948C40.7386 14.1 40.7386 13.724 40.4002 13.4232C40.325 13.3668 40.231 13.2728 40.1182 13.3292C40.0242 13.3668 40.0994 13.4796 40.0806 13.5548C40.0806 13.6488 40.0806 13.7428 40.0618 13.8368V13.8556Z"
          fill="#173CBA"
        />
        <path
          d="M33.0118 4.28641C33.1622 4.58721 33.5382 4.68121 33.839 4.53081C34.1962 4.36161 34.3654 4.04201 34.2338 3.70361C33.839 2.82001 33.4066 1.97401 32.9554 1.14681C32.8426 0.940008 32.6546 0.864808 32.4666 0.846008C31.9402 0.846008 31.5642 1.35361 31.771 1.80481C32.1658 2.65081 32.5982 3.47801 33.0306 4.28641H33.0118Z"
          fill="#173CBA"
        />
        <path
          d="M41.5658 4.56841C41.8854 4.66241 42.1862 4.54961 42.3742 4.21121C42.8066 3.42161 43.2202 2.61321 43.6338 1.82361C43.709 1.67321 43.7278 1.52281 43.6714 1.35361C43.5774 1.07161 43.3706 0.902406 43.0698 0.864806C42.7878 0.827206 42.5622 0.958806 42.4306 1.20321C41.9982 2.01161 41.5658 2.83881 41.1334 3.64721C41.077 3.74121 41.077 3.85401 41.077 3.94801C41.077 4.26761 41.265 4.49321 41.5658 4.58721V4.56841Z"
          fill="#173CBA"
        />
        <path
          d="M29.9098 6.61762C30.0414 6.74922 30.2106 6.80562 30.3986 6.78682C30.6806 6.74922 30.8686 6.61762 30.9814 6.37322C31.0942 6.11002 31.0566 5.84682 30.8686 5.64002C30.2482 5.00082 29.6278 4.36162 28.9886 3.74122C28.857 3.60962 28.7066 3.55322 28.5374 3.55322C28.2554 3.55322 28.0298 3.68482 27.8982 3.94802C27.7666 4.21122 27.8042 4.45562 27.9922 4.64362C28.6314 5.30162 29.2706 5.95962 29.9098 6.61762Z"
          fill="#173CBA"
        />
        <path
          d="M45.3071 6.63639C45.3823 6.57999 45.4387 6.52359 45.4951 6.46719C46.0591 5.88439 46.6043 5.32039 47.1495 4.73759C47.2811 4.60599 47.4127 4.45559 47.3939 4.24879C47.3939 3.96679 47.2623 3.74119 46.9991 3.60959C46.7547 3.49679 46.4915 3.51559 46.2847 3.70359C46.0967 3.87279 45.9087 4.07959 45.7207 4.26759C45.2695 4.73759 44.7995 5.18879 44.3671 5.65879C44.1039 5.94079 44.1227 6.33559 44.3671 6.59879C44.6115 6.86199 44.9874 6.88079 45.2882 6.63639H45.3071Z"
          fill="#173CBA"
        />
        <path
          d="M37.0162 3.29C37.0162 3.6848 37.2982 3.9292 37.6554 3.9292C38.0126 3.9292 38.3134 3.6472 38.3134 3.29C38.3134 2.4252 38.3134 1.5416 38.3134 0.658C38.3134 0.2632 38.0314 0 37.6554 0C37.2794 0 37.0162 0.2632 36.9974 0.658C36.9974 1.0904 36.9974 1.5228 36.9974 1.9552C36.9974 2.3876 36.9974 2.8388 36.9974 3.2712L37.0162 3.29Z"
          fill="#173CBA"
        />
        <path
          d="M38.2758 14.5324C38.5014 14.6264 38.727 14.6076 38.9338 14.4572C39.2722 14.2128 39.3474 13.8556 39.3286 13.4608C39.3286 13.2916 39.3286 13.1224 39.291 12.9532C39.1782 12.6148 38.8774 12.4268 38.539 12.4644C38.2382 12.502 38.0502 12.7464 38.0314 13.1036C38.0314 13.4044 38.0314 13.7052 38.0314 14.006C38.0314 14.2316 38.0502 14.4196 38.2758 14.5136V14.5324Z"
          fill="#173CBA"
        />
        <path
          d="M37.223 13.1224C37.223 12.7276 37.0538 12.502 36.7154 12.4644C36.377 12.4268 36.0386 12.6712 35.9634 13.0096C35.907 13.2916 35.907 13.5924 35.9634 13.8744C36.0198 14.1376 36.1702 14.3444 36.4146 14.4948C36.8094 14.7204 37.2042 14.4948 37.223 14.0436C37.223 13.8932 37.223 13.724 37.223 13.5736C37.223 13.4232 37.223 13.2728 37.223 13.1224Z"
          fill="#173CBA"
        />
      </svg>
    ),
  },
  {
    id: 2,
    title: "One free Application to Tie Up Partnered Universities*",
    height: "h-[250px]",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="54"
        height="64"
        viewBox="0 0 54 64"
        fill="none"
      >
        <path
          d="M45.208 7.63214H37.4189V15.4212H45.208V7.63214Z"
          fill="#173CBA"
        />
        <path
          d="M34.4562 18.2072V6.10175H23.6064V27.2323C26.1962 27.4482 28.2563 29.6063 28.2563 32.255C28.2563 34.9037 26 37.2973 23.214 37.2973C20.428 37.2973 22.5273 37.2581 22.1938 37.1992L22.9785 35.4923C23.057 35.4923 23.1355 35.4923 23.214 35.4923C24.9994 35.4923 26.4709 34.0404 26.4709 32.2354C26.4709 30.4304 25.2348 29.2139 23.626 29.0177V34.8645H22.0368L19.1919 41.0643L15.1502 49.854C14.8559 47.3427 14.5616 44.8314 14.2477 42.32L7.65544 48.2256L5.67383 46.0282L12.2661 40.1226C9.794 39.5536 7.34152 38.9846 4.86942 38.4157L14.0515 35.3353L15.5034 34.8448H0.592285V56.5052C0.592285 60.645 3.94728 64 8.08707 64H39.2042C43.344 64 46.699 60.645 46.699 56.5052V18.168H34.4758L34.4562 18.2072ZM28.7272 59.5463H18.5052C17.4457 59.5463 16.5825 58.683 16.5825 57.6235C16.5825 56.564 17.4457 55.7008 18.5052 55.7008H28.7272C29.7866 55.7008 30.6499 56.564 30.6499 57.6235C30.6499 58.683 29.7866 59.5463 28.7272 59.5463Z"
          fill="#173CBA"
        />
        <path d="M48.0136 0H41.9119V6.10178H48.0136V0Z" fill="#00CC99" />
        <path
          d="M53.1145 7.61249H48.6608V12.0662H53.1145V7.61249Z"
          fill="#00CC99"
        />
        <path
          d="M53.1146 1.39307H50.1913V4.31643H53.1146V1.39307Z"
          fill="#00CC99"
        />
        <path
          d="M18.152 32.255C18.152 32.412 18.152 32.5493 18.1717 32.7063L19.9571 32.1177C20.0355 30.3911 21.4678 29.0177 23.214 29.0177C24.9601 29.0177 23.4886 29.0177 23.626 29.0374V34.8841H22.0368L23.2336 32.2943L15.523 34.8841H0.611877V13.5965C0.611877 9.45674 3.96687 6.10175 8.10666 6.10175H23.6456V27.2323C23.5083 27.2323 23.3709 27.2323 23.2336 27.2323C20.4476 27.2323 18.1913 29.4886 18.1913 32.2746L18.152 32.255Z"
          fill="#00CC99"
        />
      </svg>
    ),
  },
  {
    id: 3,
    title: "Career Book",
    height: "h-[190px]",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="65"
        height="79"
        viewBox="0 0 65 79"
        fill="none"
      >
        <path
          d="M53.0235 69.5557C52.6486 69.2879 52.3451 68.9844 52.113 68.6095C50.7026 66.9135 49.9885 64.6461 50.3455 62.2181C50.9347 58.2369 54.4875 55.2732 58.5223 55.3804C58.6829 55.3804 58.8258 55.3804 58.9864 55.4161C59.3078 53.6129 59.2364 51.774 59.3614 49.9709C59.4863 48.132 59.0757 47.7392 57.3083 48.0963C54.0768 48.739 50.8454 49.4353 47.6319 50.1315C43.5256 51.0242 39.4373 51.9347 35.3311 52.8095C34.7062 52.9345 34.2242 53.1844 33.8493 53.7379C33.028 54.9697 31.5105 54.9519 30.7428 53.6843C30.4036 53.1309 29.9573 52.9345 29.4217 52.8095C21.9769 51.1849 14.5322 49.5781 7.08744 47.9535C5.87342 47.6857 5.19501 48.2927 5.23071 49.3996C5.28427 51.3813 5.49851 53.363 5.65919 55.3982C5.87342 55.3982 6.08766 55.3804 6.3019 55.3804C10.7473 55.3804 14.3715 59.0045 14.3715 63.45C14.3715 67.8954 13.7466 67.0027 12.6933 68.3596C12.4434 68.8059 12.0863 69.1987 11.5864 69.5379C10.301 70.6626 8.64066 71.3768 6.81964 71.5017C6.81964 72.7157 6.85535 73.7869 8.46213 74.0547C13.0325 74.8224 17.6029 75.5365 22.1376 76.4649C24.7442 77.0005 27.565 76.8577 29.8859 78.3752C30.475 78.7679 31.1713 79 31.8854 79H32.7959C33.4565 79 34.0992 78.8215 34.6705 78.4823C35.456 78.0181 36.2059 77.5004 37.1699 77.3397C43.3114 76.3042 49.435 75.2152 55.5765 74.144C57.5939 73.7869 57.9688 73.412 57.7367 71.4839C55.9514 71.3589 54.3268 70.6448 53.0592 69.5379L53.0235 69.5557ZM34.0099 73.7334C34.0099 74.6796 33.2423 75.4473 32.296 75.4473C31.3498 75.4473 32.2425 75.4473 32.2246 75.4473H32.1889C31.689 75.4651 31.4034 75.3223 31.2248 75.0723C30.8321 74.751 30.5643 74.269 30.5643 73.7334V58.8617C30.5643 57.9155 31.332 57.13 32.2782 57.13C33.2244 57.13 33.1887 57.3263 33.4922 57.6299C33.7957 57.9334 33.9921 58.3797 33.9921 58.8439V73.7155L34.0099 73.7334Z"
          fill="#00CC99"
        />
        <path
          d="M13.2471 46.186C13.3542 46.2931 13.4256 46.4002 13.5149 46.4181C18.6744 47.5428 23.8518 48.5783 28.9935 49.828C31.1359 50.3457 33.064 50.4707 35.2778 49.9173C40.1339 48.6854 45.0256 47.5428 49.9888 46.7573C51.0064 46.5966 51.5063 45.9717 51.1671 44.8827C50.9528 44.1864 50.7386 43.4901 50.1673 43.0081C47.0252 40.4373 43.1867 39.741 39.3662 38.6698C39.3483 41.1514 39.4554 42.7225 39.5804 45.3826C37.4916 44.6149 35.5099 43.9365 33.5818 43.1509C32.707 42.7939 31.9571 42.7582 31.0645 43.1331C29.1185 43.9365 27.1011 44.6149 25.0301 45.3826C25.0658 43.0081 25.2265 41.0621 25.2801 38.6698C21.9237 39.5982 18.6923 40.3837 15.7465 42.0083C14.1219 42.901 13.3006 44.3114 13.2828 46.1681L13.2471 46.186Z"
          fill="#173CBA"
        />
        <path
          d="M6.28428 68.895C9.28172 68.895 11.7116 66.4651 11.7116 63.4676C11.7116 60.4702 9.28172 58.0403 6.28428 58.0403C3.28684 58.0403 0.856934 60.4702 0.856934 63.4676C0.856934 66.4651 3.28684 68.895 6.28428 68.895Z"
          fill="#173CBA"
        />
        <path
          d="M59.1285 68.8954C62.0874 68.4161 64.0976 65.629 63.6183 62.6701C63.1391 59.7112 60.3519 57.7011 57.3931 58.1803C54.4342 58.6595 52.424 61.4467 52.9033 64.4056C53.3825 67.3645 56.1696 69.3746 59.1285 68.8954Z"
          fill="#173CBA"
        />
        <path
          d="M32.8318 20.0848L42.4546 15.5501L55.4874 9.39074L32.1712 0L9.51562 9.39074L22.2806 15.2466L32.8318 20.0848Z"
          fill="#00CC99"
        />
        <path
          d="M11.9433 27.9401C12.3003 27.9401 12.6396 27.9758 12.9609 28.0651V12.3543L10.9257 11.426V28.0651C11.247 27.9937 11.5862 27.9401 11.9433 27.9401Z"
          fill="#173CBA"
        />
        <path
          d="M11.9435 35.7062C13.7289 35.7062 15.1571 34.2601 15.1571 32.4926C15.1571 30.7252 14.2287 29.8682 12.9612 29.4397C12.6398 29.3326 12.3006 29.2791 11.9435 29.2791C11.5865 29.2791 11.2473 29.3326 10.9259 29.4397C9.64049 29.8682 8.72998 31.0644 8.72998 32.4926C8.72998 33.9209 10.1761 35.7062 11.9435 35.7062Z"
          fill="#00CC99"
        />
        <path
          d="M32.2605 37.1523C37.7236 37.1523 42.169 31.6893 42.169 24.9408C42.169 18.1923 41.7762 21.0845 41.0978 19.4242L32.7069 23.3876L23.5304 19.1743C22.7805 20.8882 22.3521 22.852 22.3521 24.9408C22.3521 31.6714 26.7796 37.1523 32.2605 37.1523Z"
          fill="#173CBA"
        />
      </svg>
    ),
  },
];

const CollegeMentorAchievers = () => {
  const [swiperRef, setSwiperRef] = useState<SwiperClass>();
  const [navBtnDisabled, setNavBtnDisabled] = useState({
    prev: true,
    next: false,
  });
  const [currentSlide, setCurrentSlide] = useState(0);
  const [totalSlides, setTotalSlides] = useState(0);
  const [isPrevHovered, setIsPrevHovered] = useState(false);

  useEffect(() => {
    if (swiperRef) {
      swiperRef.update();
      setTotalSlides(swiperRef.slides.length);
    }
  }, [swiperRef]);

  const handleSlideChange = () => {
    if (swiperRef) {
      setCurrentSlide(swiperRef.realIndex || 0);
      setNavBtnDisabled({
        prev: swiperRef.isBeginning,
        next: swiperRef.isEnd,
      });
    }
  };

  const handlePrevious = useCallback(() => {
    swiperRef?.slidePrev();
  }, [swiperRef]);

  const handleNext = useCallback(() => {
    swiperRef?.slideNext();
  }, [swiperRef]);

  const progressBarElement = (
    <div className="flex gap-4 items-center">
      <span>{currentSlide + 1}</span>
      <div className="w-24 h-1 bg-[#D9D9D9]">
        <div
          className="h-full bg-[#173CBA]"
          style={{
            width: totalSlides
              ? ((currentSlide + 1) / totalSlides) * 100 + "%"
              : "0%",
          }}
        ></div>
      </div>
      <span>{totalSlides}</span>
    </div>
  );

  const prevButton = (
    <button
      className={`${navBtnDisabled.prev ? "" : ""} p-2.5`}
      onClick={handlePrevious}
      onMouseEnter={() => setIsPrevHovered(true)}
      onMouseLeave={() => setIsPrevHovered(false)}
    >
      <LeftArrow />
    </button>
  );

  const nextButton = (
    <button
      className={`${navBtnDisabled.next ? "" : ""} p-2.5`}
      onClick={handleNext}
    >
      <RightArrow isPrevHovered={isPrevHovered} />
    </button>
  );

  return (
    <div className="w-full  bg-[#F4F4F4] flex flex-col items-center py-6 max-md:pb-0 max-md:overflow-hidden">
      <div className="container flex flex-col items-center text-center mx-auto gap-6">
        <div className="xl:w-[1064px] space-y-2 max-xl:w-full max-lg:mb-10">
          <h2 className="text-[40px] max-md:text-[24px] font-bold text-[#0C9] leading-[45px] max-md:leading-9">
            College Mentor Services
          </h2>
          <h3 className="relative text-[30px] min-max-xs:text-[24px] min-max-xss:text-[22px] max-md:leading-9 font-normal text-[#173CBA] leading-[45px]">
            We Educate | We Inspire | You Lead
          </h3>
        </div>

        <div className="flex flex-row w-full px-8 justify-between items-center my-auto max-lg:flex-col max-lg:gap-10">
          <div className="w-[43%] flex justify-center relative max-lg:w-full">
            <div className="relative flex items-center justify-center w-[353px] h-[271px] max-md:h-[231px]  rounded-[353px] border border-[#16499F]">
              <img
                src="/images/college-mentor-services-icon.webp"
                alt="College Mentor Services Icon"
                className="w-[156px] h-[156px] max-md:w-[96px] max-md:h-[96px]"
              />
            </div>
            <div className="absolute flex w-full flex-col gap-5 max-md:gap-[32px]">
              <div className="flex flex-row justify-center">
                <div className="md:w-[176px] max-md:py-[2px] xl:mt-[-42px] min-max-xss:w-[147px]  min-max-xs:w-[147px]  max-lg:mt-[-35px] md:px-[15px] bg-white md:py-[10px] rounded-[5px] items-center justify-center border-[#747474] border-[0.5px]">
                  <p className="text-[#383838]  text-[23px] min-max-xss:text-[18px] min-max-xs:[text-18px] font-normal leading-[32px] max-md:leading-6">
                    Student Buddy Mentor
                  </p>
                </div>
              </div>
              <div className="flex flex-row justify-between">
                <div className="md:w-[176px] min-max-xs:ml-[-11%] min-max-xss:ml-[-14%] min-max-xss:px-1 md:h-[52px] px-[15px] bg-white py-[10px]  rounded-[5px] items-center justify-center border-[#747474] border-[0.5px]">
                  <p className="text-[#383838]  text-[23px] max-md:text-[18px] max-md:leading-6 font-normal leading-[32px]">
                    Loan Mentor
                  </p>
                </div>
                <div className="md:w-[183px] min-max-xs:mr-[-11%] min-max-xss:mr-[-14%] min-max-xss:px-1 md:h-[52px] px-[15px] bg-white py-[10px] rounded-[5px] items-center justify-center border-[#747474] border-[0.5px]">
                  <p className="text-[#383838]  text-[23px] max-md:text-[18px] max-md:leading-6 font-normal leading-[32px]">
                    Career Mentor
                  </p>
                </div>
              </div>
              <div className="flex flex-row justify-between">
                <div className="md:w-[176px] min-max-xs:w-[130px] min-max-xss:w-[120px] min-max-xs:ml-[-11%] min-max-xss:ml-[-14%]  md:px-[15px] bg-white md:py-[10px] max-md:p-1 rounded-[5px] items-center justify-center border-[#747474] border-[0.5px]">
                  <p className="text-[#383838]  text-[23px] font-normal max-md:text-[18px] max-md:leading-6 leading-[32px]">
                    Scholarship Mentor
                  </p>
                </div>
                <div className="md:w-[176px] min-max-xs:w-[130px] min-max-xss:w-[120px] min-max-xs:mr-[-11%] min-max-xss:mr-[-14%] max-md:p-1 md:px-[15px] bg-white md:py-[10px] rounded-[5px] items-center justify-center border-[#747474] border-[0.5px]">
                  <p className="text-[#383838]  text-[23px] max-md:text-[18px] max-md:leading-6 font-normal leading-[32px]">
                    Admission Mentor
                  </p>
                </div>
              </div>
              <div className="flex flex-row justify-center">
                <div className="md:w-[186px] max-md:px-1 md:h-[52px] px-[15px] bg-white py-[10px] rounded-[5px] items-center justify-center border-[#747474] border-[0.5px]">
                  <p className="text-[#383838]  max-md:text-[18px] max-md:leading-6 text-[23px] font-normal leading-[32px]">
                    Health Mentor
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="w-[48%] flex max-md:flex-col  max-md:w-[78%] py-16 max-md:py-4 min-max-md:w-full">
            <Swiper
              onSwiper={setSwiperRef}
              onSlideChange={handleSlideChange}
              modules={[Autoplay, Navigation]}
              spaceBetween={30}
              slidesPerView={1}
              loop={true}
              autoplay={{
                delay: 1500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              breakpoints={{
                640: { slidesPerView: 1 },
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 3 },
              }}
              className="max-md:w-full"
            >
              {mentorServices.map((service) => (
                <SwiperSlide key={service.id}>
                  <div
                    className={`flex flex-col items-center justify-center max-md:my-1 w-full max-md:h-[250px] ${
                      service.height
                    } bg-white shadow-md rounded-md  ${
                      service.id !== 2 ? "my-7" : "my-1"
                    } gap-4`}
                  >
                    {service.icon}
                    <p className="text-[#383838] text-center text-[24px] leading-8 px-4">
                      {service.title}
                    </p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="flex justify-center container swiper-buttons md:hidden relative mx-auto py-2">
              {prevButton}
              {progressBarElement}
              {nextButton}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CollegeMentorAchievers;
const LeftArrow = () => {
  return (
    <div className="p-4 border border-black hover:border-[#173CBA] rounded-full bg-white hover:bg-[#173CBA] group">
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className="fill-current text-black group-hover:text-white"
          d="M13.7917 5.45842H3.375L6.80208 2.03134C6.89972 1.9345 6.97721 1.8193 7.0301 1.69236C7.08298 1.56542 7.11021 1.42927 7.11021 1.29176C7.11021 1.15425 7.08298 1.01809 7.0301 0.891158C6.97721 0.764222 6.89972 0.649012 6.80208 0.552176C6.60691 0.358165 6.3429 0.249268 6.06771 0.249268C5.79252 0.249268 5.5285 0.358165 5.33333 0.552176L0.864584 5.03134C0.473346 5.42024 0.252326 5.94844 0.25 6.50008V6.50008C0.255069 7.04811 0.47588 7.57207 0.864584 7.95842L5.33333 12.4376C5.43046 12.534 5.54562 12.6104 5.67226 12.6623C5.7989 12.7142 5.93452 12.7407 6.07139 12.7402C6.20826 12.7398 6.3437 12.7123 6.46996 12.6595C6.59623 12.6067 6.71085 12.5295 6.80729 12.4324C6.90373 12.3352 6.9801 12.2201 7.03203 12.0934C7.08396 11.9668 7.11044 11.8312 7.10995 11.6943C7.10947 11.5574 7.08203 11.422 7.02921 11.2957C6.97638 11.1695 6.89921 11.0549 6.80208 10.9584L3.375 7.54175H13.7917C14.0679 7.54175 14.3329 7.432 14.5282 7.23665C14.7236 7.0413 14.8333 6.77635 14.8333 6.50008C14.8333 6.22382 14.7236 5.95887 14.5282 5.76352C14.3329 5.56817 14.0679 5.45842 13.7917 5.45842Z"
        />
      </svg>
    </div>
  );
};

const RightArrow = ({ isPrevHovered }: { isPrevHovered: boolean }) => {
  return (
    <div
      className={`p-4 border rounded-full ${
        isPrevHovered ? "bg-white border-black" : "bg-blue border-blue"
      }`}
    >
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className={`${
            isPrevHovered
              ? "fill-current text-black"
              : "fill-current text-white"
          }`}
          d="M1.20833 5.45842H11.625L8.19792 2.03134C8.10028 1.9345 8.02279 1.8193 7.9699 1.69236C7.91702 1.56542 7.88979 1.42927 7.88979 1.29176C7.88979 1.15425 7.91702 1.01809 7.9699 0.891158C8.02279 0.764222 8.10028 0.649012 8.19792 0.552176C8.39309 0.358165 8.6571 0.249268 8.93229 0.249268C9.20748 0.249268 9.4715 0.358165 9.66667 0.552176L14.1354 5.03134C14.5267 5.42024 14.7477 5.94844 14.75 6.50008V6.50008C14.7449 7.04811 14.5241 7.57207 14.1354 7.95842L9.66667 12.4376C9.56954 12.534 9.45438 12.6104 9.32774 12.6623C9.2011 12.7142 9.06548 12.7407 8.92861 12.7402C8.79174 12.7398 8.6563 12.7123 8.53004 12.6595C8.40377 12.6067 8.28915 12.5295 8.19271 12.4324C8.09627 12.3352 8.0199 12.2201 7.96797 12.0934C7.91604 11.9668 7.88956 11.8312 7.89005 11.6943C7.89053 11.5574 7.91797 11.422 7.97079 11.2957C8.02362 11.1695 8.10079 11.0549 8.19792 10.9584L11.625 7.54175H1.20833C0.932065 7.54175 0.667112 7.432 0.471762 7.23665C0.276411 7.0413 0.166666 6.77635 0.166666 6.50008C0.166666 6.22382 0.276411 5.95887 0.471762 5.76352C0.667112 5.56817 0.932065 5.45842 1.20833 5.45842Z"
        />
      </svg>
    </div>
  );
};
